import React, { useState } from "react";
import {
  Button,
  Dialog,
  Card,
  CardBody,
  CardFooter,
  Typography,
} from "@material-tailwind/react";
import { useDispatch, useSelector } from "react-redux";
import { setListOrderComments } from "store/actions/Store/list";

const Modal = ({ isOpen, handleModalToggle, modalData, submitHandler }) => {
  const { selectedStore } = useSelector((store) => store.selectedStore);
  const [comments, setComments] = useState("");
  const dispatch = useDispatch();
  const addCommentsHandler = () => {
    dispatch(setListOrderComments(comments));
  };

  return (
    <Dialog
      size="xs"
      open={isOpen}
      handler={handleModalToggle}
      className={`overflow-auto bg-transparent shadow-none h-auto`}
    >
      <Card className="mx-auto   max-w-[24rem ]">
        <CardBody className="flex flex-col gap-2">
          <Typography variant="h4" color="blue-gray">
            {modalData.title}
          </Typography>
          <Typography variant="h5" color="blue-gray">
            {modalData.heading}
          </Typography>
          {Array.isArray(modalData.description) ? (
            modalData.description.map((item, index) => (
              <Typography
                key={index}
                className="text-sm text-gray-700 "
                variant="paragraph"
              >
                {item}
              </Typography>
            ))
          ) : (
            <Typography
              className="mb-3 font-normal"
              variant="paragraph"
              color="gray"
            >
              {modalData.description}
            </Typography>
          )}

          <div className={` ${modalData.discountFlag ? "" : "hidden"}`}>
            <Typography className="font-bold text-gray-900">
              Orignal Price: {modalData.orignalPrice}
            </Typography>
            <Typography className="font-bold text-gray-900">
              Discount: {modalData.discount}
            </Typography>
            <Typography className="font-bold text-gray-900">
              Discounted Price: {modalData.discountedPrice}
            </Typography>
            <div className="my-2 ">
              <label className="font-bold text-black">
                Add Comments (Optional):
              </label>
              <textarea
                placeholder="Enter any additional comments..."
                onChange={(e) => setComments(e.target.value)}
                className="w-full p-2 border border-gray-500 rounded-lg"
              />
            </div>
          </div>
        </CardBody>
        <CardFooter className="flex justify-end gap-3 pt-0 ">
          {modalData.redButton && (
            <Button
              className={`px-2 w-28 py-2 bg-${
                modalData.backgroundColor || "red-800"
              }`}
              onClick={(e) =>
                modalData.flag
                  ? submitHandler(modalData.redButton)
                  : handleModalToggle()
              }
            >
              {modalData.redButton}
            </Button>
          )}
          {modalData.purpleButton && (
            <Button
              style={{
                backgroundColor: selectedStore?.theme.color,
              }}
              className="px-2 py-2 w-28 "
              onClick={() => {
                if (modalData?.discountFlag) {
                  addCommentsHandler();
                }

                submitHandler(modalData.purpleButton);
              }}
            >
              {modalData.purpleButton}
            </Button>
          )}
        </CardFooter>
      </Card>
    </Dialog>
  );
};

export default Modal;
